import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Overview from "./pages/Overview";
import DealsCoupons from "./pages/DealsCoupons";
import Review from "./pages/Review";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CatalogMui from "./pages/CatalogMui";
import SingleProduct from "./pages/SingleProduct";
import Cart from "./pages/Cart";
import DiscountDelivery from "./pages/DiscountDelivery";
import Confirmation from "./pages/Confirmation";
import Dashboard from "./pages/Dashboard";
import AllOrders from "./pages/AllOrders";
import OpenOrders from "./pages/OpenOrders";
import CompletedOrders from "./pages/CompletedOrders";
import CanceledOrders from "./pages/CanceledOrders";
import OrderDetails from "./pages/OrderDetails";
import Search from "./pages/Search";
import OtherOrders from "pages/OtherOrders";
import TermsAndConditions from "pages/TermsAndConditions";
import PrivacyPolicy from "pages/PrivacyPolicy";
import ScrollToTop from "components/ScrollToTop";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { decodeJwt } from "./utils/jwtHelper";
import { setHulUser } from "./redux/hulAuth/hulAuthSlice";
import { GlobalDebug } from "remove-consoles";
import { Suspense } from "react";
import ShopCostBoHome from "pages/ShopCostBoHome";
import UserAuth from "pages/UserAuth";
import { getAccountData } from "services/api_calls/dashboard_api/DashboardApi";
import { getAccessToken, storeUserInfo } from "utils/authHelpers";
import ReturnPolicy from "pages/ReturnPolicy";
import { getUserLocation } from "utils/geoLocationHelper";
import FullHeightLoader from "components/FullHeightLoader";
import { getCommercialDetails } from "redux/productDescription/ProductDescriptionSlice";
import { getBusinessIdData } from "services/api_calls/root/RootApi";
import ShareAndEarn from "./pages/ShareAndEarn";
import AffiliateEnroll from "./pages/AffiliateEnroll";
import AffiliateBankDetails from "pages/AffiliateBankDetails";
import AffiliatePrograms from "./pages/AffiliatePrograms";
import PayCartConfirmation from "./pages/PayCartConfirmation";
import PaycartDetails from "./pages/PaycartDetails";
import AddAddress from "pages/DiscountDelivery/AddAddress";
import ProductDetail from "pages/ProductDetail";
import { setLoginData, updateIsLogin } from "redux/authRedux/authSlice";
import {
  createHulPartnerUser,
  decryptHulPartnerUser,
  getHulAuthToken,
} from "services/api_calls/auth/hulAuthApi";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { createCartHelper, updateMergeCartHelper } from "utils/cartHelper";
import {
  checkCartOrderProducts,
  clearLocalCartData,
  createCart,
  updateCartDetails,
} from "redux/cart/CartSlice";
import { getCartDetails } from "redux/addToCart/AddToCartSlice";
import { Box, Button, Card, Typography } from "@mui/material";

const AppContent = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [isHulTokenError, setIsHulTokenError] = useState(false);

  const { businessId } = useSelector((state) => state.rootSlice);

  const handleHulLogin = async (encData) => {
    try {
      setLoading(true);

      const decodedToken = await decryptHulPartnerUser({
        partnerType: "HUL",
        encData,
      });

      console.log("HUL___decrypt", { decodedToken, encData });

      if (decodedToken && decodedToken.Zipcode) {
        // Create the Hul partner user
        const partnerUserResponse = await createHulPartnerUser({
          partnerType: "HUL",
          encData: encData,
        });

        console.log("HUL___create", { partnerUserResponse });

        if (partnerUserResponse?.success) {
          // Get the auth token using encData
          const authTokenResponse = await getHulAuthToken(encData);
          console.log("HUL___getHulUser", authTokenResponse?.access_token);

          if (authTokenResponse) {
            const accountResponse = await getAccountData();
            if (accountResponse) {
              if (accountResponse.account) {
                storeUserInfo(accountResponse);
              } else {
                storeUserInfo({
                  success: true,
                  account: {
                    email: "",
                    phonenumber: "+91",
                    xmppId: "",
                    userStatus: "active",
                    type: 0,
                    delegatesInfo: [],
                    rewardDelegateInfo: [],
                    gstDetails: [],
                    loc: {
                      x: 0,
                      y: 0,
                      coordinates: [0, 0],
                      type: "Point",
                    },
                    photoURL: "",
                    name: "HUL User",
                  },
                });
              }

              dispatch(getCartDetails(businessId)).then((res) => {
                sessionStorage.setItem(
                  "cartData",
                  JSON.stringify(res?.payload?.detail)
                );
              });
              dispatch(setHulUser({ ...decodedToken, encData }));
              dispatch(setLoginData());
              dispatch(updateIsLogin());
            }
          }
        }
      }
    } catch (error) {
      console.error("HUL login process failed:", error?.data?.detail);
      setIsHulTokenError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");

    if (token) {
      handleHulLogin(token);
    } else {
      const hulUser = JSON.parse(sessionStorage.getItem("hulUserData") || null);
      console.log("HUL______TESTIII", hulUser);
      if (hulUser) {
        dispatch(setHulUser(hulUser));
      }
      // if(!token){
      //   setLoading(false);
      // }
    }
  }, [location, dispatch, businessId]);

  useEffect(() => {
    if (
      window.location.hostname !== "prelive-shop.costbo.com" &&
      window.location.hostname !== "prelive-ondc.costbo.com" &&
      window.location.hostname !== "localhost"
    ) {
      const handleKeyDown = (e) => {
        // Disable shortcuts for DevTools (macOS and Windows)
        if (
          (e.metaKey &&
            e.altKey &&
            (e.key === "I" || e.key === "J" || e.key === "C")) || // macOS DevTools shortcuts
          (e.ctrlKey &&
            e.shiftKey &&
            (e.key === "I" || e.key === "J" || e.key === "C")) || // Windows/Linux DevTools shortcuts
          e.key === "F12" || // Universal F12 key
          (e.metaKey && e.key === "U") || // macOS View Source
          (e.ctrlKey && e.key === "U") // Windows/Linux View Source
        ) {
          e.preventDefault();
          alert("This action is disabled!");
        }
      };

      const handleContextMenu = (e) => {
        e.preventDefault(); // Disable right-click menu
      };

      // Add event listeners
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("contextmenu", handleContextMenu);

      // Cleanup event listeners on unmount
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("contextmenu", handleContextMenu);
      };
    }
  }, []);

  useEffect(() => {
    process.env.REACT_APP_ENV === "STAGING" && GlobalDebug(false);
    // console.log = () => {}
    console.warn = () => {};
    // checkTokenValid();
    getUserLocation();
  }, []);

  return (
    <Suspense fallback={<p></p>}>
      {!loading && isHulTokenError ? (
        <HulTokenError />
      ) : (
        <ScrollToTop>
          <Routes>
            <Route path="/" exact element={<ShopCostBoHome />} />
            <Route path="/:businessName" exact element={<Home />} />
            <Route path="/:businessName/catalog" element={<CatalogMui />} />
            <Route path="/:businessName/overview" element={<Overview />} />
            <Route
              path="/:businessName/dealsCoupons"
              element={<DealsCoupons />}
            />
            <Route path="/:businessName/review" element={<Review />} />
            <Route
              path="/:businessName/singleProduct/:productId"
              element={<ProductDetail />}
              // element={<SingleProduct />}
            />
            <Route
              path="/:businessName/oldSingleProduct/:productId"
              element={<SingleProduct />}
            />
            <Route path="/:businessName/cart" element={<Cart />} />
            <Route
              path="/:businessName/discountDelivery"
              element={<DiscountDelivery />}
            />
            <Route path="/:businessName/addAddress" element={<AddAddress />} />

            <Route
              path="/:businessName/confirmation"
              element={<Confirmation />}
            />
            <Route
              path="/:businessName/easycartConfirmation"
              element={<PayCartConfirmation />}
            />
            <Route path="/:businessName/dashboard" element={<Dashboard />} />
            <Route path="/:businessName/allOrders" element={<AllOrders />} />
            <Route path="/:businessName/openOrders" element={<OpenOrders />} />
            <Route
              path="/:businessName/completedOrders"
              element={<CompletedOrders />}
            />
            <Route
              path="/:businessName/canceledOrders"
              element={<CanceledOrders />}
            />
            <Route
              path="/:businessName/otherOrders"
              element={<OtherOrders />}
            />
            <Route
              path="/:businessName/orderDetails/:cartId"
              element={<OrderDetails />}
            />
            <Route
              path="/:businessName/easycart/:paycartId"
              element={<PaycartDetails />}
            />

            <Route path="/:businessName/search" element={<Search />} />
            {/* SubDomain Auth */}
            <Route path="/:businessName/userauth" element={<UserAuth />} />
            <Route
              //  path='/:businessName/termsAndConditions'
              path="/termsAndConditions"
              element={<TermsAndConditions />}
            />
            <Route
              //  path='/:businessName/privacyPolicy'
              path="/privacyPolicy"
              element={<PrivacyPolicy />}
              // element={
              //   isLogged ? (
              //     <PrivacyPolicy />
              //   ) : (
              //     <Navigate to="/itree" replace />
              //   )
              // }
            />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            <Route path="/cancellation-policy" element={<ReturnPolicy />} />
            <Route path="/shipping-policy" element={<ReturnPolicy />} />
            <Route path="/delivery-timelines" element={<ReturnPolicy />} />

            {/* Affiliate */}
            <Route
              path="/:businessName/affiliates"
              element={<ShareAndEarn />}
            />
            <Route
              path="/:businessName/affiliateEnroll"
              element={<AffiliateEnroll />}
            />
            <Route
              path="/:businessName/affiliateBankDetails"
              exact
              element={<AffiliateBankDetails />}
            />
            <Route
              path="/:businessName/affiliateHome"
              exact
              element={<AffiliatePrograms />}
            />
          </Routes>
        </ScrollToTop>
      )}
    </Suspense>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

const HulTokenError = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
        p: 2,
      }}
    >
      <Box sx={{ p: 4, maxWidth: 400, textAlign: "center" }}>
        <ErrorOutlineIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
        <Typography variant="h5" component="h2" gutterBottom>
          Invalid Token
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          The token is invalid or has expired. Please return to the Shikhar app
          and try again.
        </Typography>
        <Button
          variant="contained"
          disableElevation
          sx={{
            mt: 2,
            bgcolor: "#002F6F",
            "&:hover": {
              bgcolor: "#002F6F",
            },
          }}
          onClick={() => {
            window.open("https://shikar-5e94a.web.app/1", "_self");
          }}
        >
          Go Back to Shikhar App
        </Button>
      </Box>
    </Box>
  );
};
